<div class="container-fluid p-0" style="max-height: 90vh; overflow-y: auto;">
  <!-- Upload Step -->
  <div *ngIf="currentStep === 'upload'">
    <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
      <h4 class="mb-0">Upload Portfolio</h4>
    </div>

    <div class="alert alert-info d-flex align-items-center mx-3 mb-3" *ngIf="!isBenchmark && existingCount > 0">
      <i class="material-icons me-2">info</i>
      <span>Watchlist has {{ existingCount }}/{{ maxCompanies }} companies. You can upload up to {{ remainingSlots }}
        more.</span>
    </div>

    <div class="alert alert-warning d-flex align-items-center mx-3 mb-3" *ngIf="!isBenchmark && remainingSlots <= 0">
      <i class="material-icons me-2">warning</i>
      <span>Watchlist is full ({{ existingCount }}/{{ maxCompanies }}). Cannot add more companies.</span>
    </div>

    <div class="px-3">
      <!-- Sample Data Table -->
      <div class="card mb-3">
        <div class="card-header bg-light">
          <h6 class="mb-0">Sample Format</h6>
        </div>
        <div class="card-body p-0">
          <table class="table table-striped table-sm mb-0">
            <thead class="table-light">
              <tr>
                <th>Company Name</th>
                <th>ISIN</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Apple Inc.</td>
                <td>US0378331005</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="text-end mb-3">
        <button class="btn btn-outline-primary btn-sm" (click)="downloadTemplate()">
          <i class="material-icons me-1" style="font-size: 18px;">download</i>
          Download Excel Template
        </button>
      </div>

      <!-- File Upload Area -->
      <div class="border border-2 border-dashed rounded p-5 text-center mb-3"
        style="border-color: #dee2e6; cursor: pointer;" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
        (click)="fileInput.click()" [class.border-primary]="selectedFile">
        <i class="material-icons text-muted mb-2" style="font-size: 48px;">cloud_upload</i>
        <p class="mb-2">Drag and drop your Excel file here, or <span class="text-primary"
            style="cursor: pointer;">browse</span></p>
        <input #fileInput type="file" accept=".xlsx,.xls,.csv" (change)="onFileSelected($event)" style="display: none;">
        <p class="mb-2">Supported formats: CSV, Excel (.xlsx, .xls), Max 5MB , Max {{maxRows}} rows</p>
      </div>
      <!-- Add after the file upload area, before the file selected alert -->
      <!-- File Size Warning -->
      <div *ngIf="selectedFile && selectedFile.size > maxFileSize" class="alert alert-danger mb-3">
        <div class="d-flex align-items-center">
          <i class="material-icons me-2" style="font-size: 20px;">error</i>
          <div>
            <strong>File Too Large:</strong> File size ({{(selectedFile.size / 1024 / 1024).toFixed(1)}}MB) exceeds 5MB
            limit.
            Please use a smaller file.
          </div>
        </div>
      </div>

      <!-- Auto-selection Warning -->
      <div *ngIf="wasAutoSelected" class="alert alert-warning mb-3">
        <div class="d-flex align-items-center">
          <i class="material-icons me-2" style="font-size: 20px;">warning</i>
          <div>
            <strong>Row Limit Exceeded:</strong> File contains more than {{maxRows}} companies.
            We have auto-selected the first {{maxRows}} rows and discarded the rest.
          </div>
        </div>
      </div>
      <!-- File Selected -->
      <div *ngIf="selectedFile" class="alert alert-success d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center">
          <i class="material-icons me-2">description</i>
          <span>{{ selectedFile.name }}</span>
        </div>
        <button class="btn btn-md btn-outline-danger" (click)="clearFile()">
          <i class="bi bi-x" style="font-size: 18px;"></i>  
        </button>
      </div>

      <!-- Upload Preview -->
      <div *ngIf="uploadData.length > 0" class="mb-3">
        <h5>Upload Preview ({{ uploadData.length }} companies)</h5>
        <div style="height: 200px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px;">
          <table class="table table-striped table-sm mb-0">
            <thead class="table-light sticky-top">
              <tr>
                <th width="60">#</th>
                <th>Company Name</th>
                <th>ISIN</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of uploadData" [class.table-warning]="element.hasWarning">
                <td>{{ element.rowNumber }}</td>
                <td>
                  {{ element.name || '-' }}
                  <i *ngIf="element.hasWarning" class="material-icons text-warning ms-1"
                    style="font-size: 16px; cursor: pointer;" [title]="element.warningMessage">warning</i>
                </td>
                <td>{{ element.isin || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 p-3 border-top shadow-sm"
      style="position: sticky; bottom: 0; background: #fff; z-index: 1030;">
      <button class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
      <button class="btn btn-outline-warning" (click)="clearFile()" [disabled]="!selectedFile">Clear</button>
      <button class="btn btn-primary" (click)="processFile()"
        [disabled]="!selectedFile || uploadData.length === 0 || isProcessing || remainingSlots <= 0">
        <span *ngIf="!isProcessing" class="d-flex align-items-center">
          <i class="material-icons me-1" style="font-size: 18px;">search</i>
          Match Companies
        </span>
        <span *ngIf="isProcessing" class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          Matching Companies...
        </span>
      </button>

    </div>
  </div>

  <!-- Review Step -->
  <div *ngIf="currentStep === 'review'">
    <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
      <h4 class="mb-0">Review Matches</h4>
      <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">
        <i class="material-icons me-1" style="font-size: 18px;">arrow_back</i>
        Back to Upload
      </button>
    </div>

    <div class="px-3">
      <!-- Review Summary -->
      <div class="alert alert-success d-flex align-items-center mb-3 " style="z-index: 1020;" role="status"
        aria-live="polite">
        <i class="material-icons me-2">check_circle</i>

        <span>
          We successfully matched {{ highQualityMatches.length }} companies out of {{ matchResults.length }} uploaded.
          <span *ngIf="highQualityMatches.length < matchResults.length">
            Some partial or unmatched rows need your attention. Please manually match them using the Edit button
            <button type="button" class="btn btn-sm btn-outline-primary ms-1" disabled aria-hidden="true">
              <i class="material-icons" style="font-size: 16px;">edit</i>
            </button>.
          </span>
        </span>


      </div>

      <!-- Warning Messages -->
      <div class="alert alert-warning d-flex align-items-center mb-3"
        *ngIf="!isBenchmark && (existingCount + getSelectedCount()) > maxCompanies">
        <i class="material-icons me-2">warning</i>
        <span>Cannot add {{ getSelectedCount() }} companies. Watchlist would exceed {{ maxCompanies }} limit (currently there are
          {{ existingCount }} companies on the watchlist). Please unselect some companies.</span>
      </div>

      <div class="alert alert-info d-flex align-items-center mb-3"
        *ngIf="!isBenchmark && getSelectedCount() > 0 && (existingCount + getSelectedCount()) <= maxCompanies">
        <i class="material-icons me-2">info</i>
        <span>Ready to add {{ getSelectedCount() }} companies to watchlist ({{ existingCount + getSelectedCount() }}/{{
          maxCompanies }} total).</span>
      </div>



      <!-- Search and Sort Controls -->
      <div class="row mb-3">
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="Search companies..." [(ngModel)]="searchText">
        </div>
        <div class="col-md-3">
          <select class="form-select" [(ngModel)]="sortBy">
            <option value="score">Sort by Score</option>
            <option value="name">Sort by Name</option>
            <option value="isin">Sort by ISIN</option>
          </select>
        </div>
        <div class="col-md-3">
          <select class="form-select" [(ngModel)]="sortOrder">
            <option value="desc">High to Low</option>
            <option value="asc">Low to High</option>
          </select>
        </div>
      </div>

      <!-- Matches Tables -->
      <div class="card">
        <div class="card-header">
          <div class="btn-group w-100" role="group">
            <button type="button" class="btn" [class.btn-primary]="activeTab === 'matched'"
              [class.btn-outline-primary]="activeTab !== 'matched'" (click)="setActiveTab('matched')">
              Matched Companies ({{ filteredHighQualityMatches.length }})
            </button>
            <button type="button" class="btn" [class.btn-primary]="activeTab === 'partial'"
              [class.btn-outline-primary]="activeTab !== 'partial'" (click)="setActiveTab('partial')">
              Partial Matches / Unmatched ({{ filteredLowQualityMatches.length }})
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <!-- Matched Companies -->
          <div *ngIf="activeTab === 'matched'" class="p-3">
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" [checked]="allHighQualitySelected"
                (change)="toggleAllHighQuality()">
              <label class="form-check-label fw-bold">
                {{ allHighQualitySelected ? 'Deselect All' : 'Select All' }}
              </label>
            </div>
            <div style="max-height: 400px; overflow-y: auto;">
              <table class="table table-hover table-sm mb-0" style="table-layout: fixed; width: 100%;">
                <thead class="table-light sticky-top">
                  <tr>
                    <th style="width: 8%">Select</th>
                    <th style="width: 10%; cursor: pointer;" (click)="toggleSort('score')">
                      Score <span *ngIf="sortBy==='score'">{{ sortOrder==='asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th style="width: 25%">Name (Upload)</th>
                    <th style="width: 15%">ISIN (Upload)</th>
                    <th style="width: 25%; cursor: pointer;" (click)="toggleSort('name')">
                      Name (Matched) <span *ngIf="sortBy==='name'">{{ sortOrder==='asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th style="width: 15%; cursor: pointer;" (click)="toggleSort('isin')">
                      ISIN (Matched) <span *ngIf="sortBy==='isin'">{{ sortOrder==='asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th style="width: 7%">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let element of filteredHighQualityMatches" [class.table-warning]="element.isDuplicate"
                    [class.table-secondary]="element.isExisting"
                    [class.table-danger]="hasIssue(element) && !element.isDuplicate">
                    <td>
                      <div class="form-check"
                        *ngIf="!element.isExisting && element.gics_subindustry && (element.company_type === 'Public Company' || element.company_type === 'Public Investment Firm')">
                        <input class="form-check-input" type="checkbox" [checked]="element.selected"
                          (change)="toggleSelection(element)">
                      </div>
                    </td>
                    <td>
                      <span *ngIf="!element.isManual" class="badge bg-success text-white">{{
                        Math.round((element.match_score || 0) * 10) / 10 }}%</span>
                      <span *ngIf="element.isManual" class="badge bg-info text-white">Manual</span>
                    </td>
                    <td class="text-truncate" [title]="element.input_data.name || '-'">{{ element.input_data.name || '-'
                      }}</td>
                    <td class="text-truncate" [title]="element.input_data.isin || '-'">{{ element.input_data.isin || '-'
                      }}</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="flex-grow-1 text-truncate" [title]="element.matched_entity_name || '-'">{{
                          element.matched_entity_name || '-' }}</span>
                        <i *ngIf="element.isDuplicate" class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #ffc107; color: #000; border-radius: 50%; padding: 2px;"
                          title="Multiple rows match the same company - only one can be selected">warning</i>
                        <i *ngIf="element.isExisting" class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #28a745; color: white; border-radius: 50%; padding: 2px;"
                          title="This company is already in your watchlist and cannot be added again">check</i>
                        <i *ngIf="!element.gics_subindustry" class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #dc3545; color: white; border-radius: 50%; padding: 2px;"
                          title="Only companies with a GICS assignment can be added to watchlists.">error</i>
                        <i *ngIf="element.company_type !== 'Public Company' && element.company_type !== 'Public Investment Firm'"
                          class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #6c757d; color: white; border-radius: 50%; padding: 2px;"
                          title="Only public companies can be added to watchlists.">business</i>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="flex-grow-1 text-truncate" [title]="element.matched_isin || '-'">{{
                          element.matched_isin || '-' }}</span>
                        <i *ngIf="element.input_data.isin && element.matched_isin && element.input_data.isin !== element.matched_isin"
                          class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #17a2b8; color: white; border-radius: 50%; padding: 2px;"
                          title="The matched company shows a different ISIN than the input.">info</i>
                      </div>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-outline-primary" (click)="editMatch(element)">
                        <i class="material-icons" style="font-size: 16px;">edit</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Partial Matches -->
          <div *ngIf="activeTab === 'partial'" class="p-3">
            <div style="max-height: 400px; overflow-y: auto;">
              <table class="table table-hover table-sm mb-0" style="table-layout: fixed; width: 100%;">
                <thead class="table-light sticky-top">
                  <tr>
                    <th style="width: 8%">Select</th>
                    <th style="width: 10%; cursor: pointer;" (click)="toggleSort('score')">
                      Score <span *ngIf="sortBy==='score'">{{ sortOrder==='asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th style="width: 25%">Name (Upload)</th>
                    <th style="width: 15%">ISIN (Upload)</th>
                    <th style="width: 25%; cursor: pointer;" (click)="toggleSort('name')">
                      Name (Matched) <span *ngIf="sortBy==='name'">{{ sortOrder==='asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th style="width: 15%; cursor: pointer;" (click)="toggleSort('isin')">
                      ISIN (Matched) <span *ngIf="sortBy==='isin'">{{ sortOrder==='asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th style="width: 7%">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let element of filteredLowQualityMatches" [class.table-warning]="element.isDuplicate"
                    [class.table-secondary]="element.isExisting"
                    [class.table-danger]="hasIssue(element) && !element.isDuplicate">
                    <td>
                      <div class="form-check" *ngIf="element.gics_subindustry">
                        <input class="form-check-input" type="checkbox" [checked]="element.selected"
                          (change)="toggleSelection(element)"
                          [disabled]="element.match_quality === 'no_match' || element.isExisting">
                      </div>
                    </td>
                    <td>
                      <span *ngIf="!element.isManual" class="badge" [ngClass]="{
                        'bg-success text-white': element.match_quality === 'high',
                        'bg-warning text-dark': element.match_quality === 'low',
                        'bg-danger text-white': element.match_quality === 'no_match'
                      }">{{ Math.round((element.match_score || 0) * 10) / 10 }}%</span>
                      <span *ngIf="element.isManual" class="badge bg-info text-white">Manual</span>
                    </td>
                    <td class="text-truncate" [title]="element.input_data.name || '-'">{{ element.input_data.name || '-'
                      }}</td>
                    <td class="text-truncate" [title]="element.input_data.isin || '-'">{{ element.input_data.isin || '-'
                      }}</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="flex-grow-1 text-truncate" [title]="element.matched_entity_name || '-'">{{
                          element.matched_entity_name || '-' }}</span>
                        <!-- <i *ngIf="element.isDuplicate" class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #ffc107; color: #000; border-radius: 50%; padding: 2px;"
                          title="Multiple rows match the same company - only one can be selected">warning</i>
                        <i *ngIf="element.isExisting" class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #28a745; color: white; border-radius: 50%; padding: 2px;"
                          title="This company is already in your watchlist and cannot be added again">check</i>
                        <i *ngIf="!element.gics_subindustry" class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #dc3545; color: white; border-radius: 50%; padding: 2px;"
                          title="No GICS coverage - cannot be added">error</i>
                        <i *ngIf="element.company_type !== 'Public Company'" class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #6c757d; color: white; border-radius: 50%; padding: 2px;"
                          title="Only public companies can be added to watchlists.">business</i> -->
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="flex-grow-1 text-truncate" [title]="element.matched_isin || '-'">{{
                          element.matched_isin || '-' }}</span>
                        <!-- <i *ngIf="element.input_data.isin && element.matched_isin && element.input_data.isin !== element.matched_isin"
                          class="material-icons ms-1"
                          style="font-size: 16px; cursor: pointer; background-color: #17a2b8; color: white; border-radius: 50%; padding: 2px;"
                          title="The matched company shows a different ISIN than the input.">info</i> -->
                      </div>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-outline-primary" (click)="editMatch(element)">
                        <i class="material-icons" style="font-size: 16px;">edit</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Icon Guide -->
    <div class="alert alert-light mb-3 mx-3">
      <div class="row g-2">
        <div class="col-12">
          <small class="text-muted fw-bold">Status Icons Guide</small>
        </div>
        <div class="col-6 col-md-3">
          <i class="material-icons me-1"
            style="font-size: 16px; background-color: #28a745; color: white; border-radius: 50%; padding: 2px;">check</i>
          <small>Already in {{ isBenchmark ? 'benchmark' : 'watchlist' }}</small>
          <i class="material-icons ms-1" style="font-size: 14px; color: #6c757d; cursor: pointer;"
            title="This company is already in your watchlist and cannot be added again">help_outline</i>
        </div>
        <div class="col-6 col-md-3">
          <i class="material-icons me-1"
            style="font-size: 16px; background-color: #ffc107; color: #000; border-radius: 50%; padding: 2px;">warning</i>
          <small>Duplicate match</small>
          <i class="material-icons ms-1" style="font-size: 14px; color: #6c757d; cursor: pointer;"
            title="Multiple rows match the same company - only one can be selected">help_outline</i>
        </div>
        <div class="col-6 col-md-3">
          <i class="material-icons me-1"
            style="font-size: 16px; background-color: #dc3545; color: white; border-radius: 50%; padding: 2px;">error</i>
          <small>No GICS</small>
          <i class="material-icons ms-1" style="font-size: 14px; color: #6c757d; cursor: pointer;"
            title="Only companies with a GICS assignment can be added to watchlists.">help_outline</i>
        </div>
        <div class="col-6 col-md-3">
          <i class="material-icons me-1"
            style="font-size: 16px; background-color: #17a2b8; color: white; border-radius: 50%; padding: 2px;">info</i>
          <small>Different ISIN</small>
          <i class="material-icons ms-1" style="font-size: 14px; color: #6c757d; cursor: pointer;"
            title="The matched company shows a different ISIN than the input.">help_outline</i>
        </div>
        <div class="col-6 col-md-3">
          <i class="material-icons me-1"
            style="font-size: 16px; background-color: #6c757d; color: white; border-radius: 50%; padding: 2px;">business</i>
          <small>Not a public company</small>
          <i class="material-icons ms-1" style="font-size: 14px; color: #6c757d; cursor: pointer;"
            title="Only public companies can be added to watchlists.">help_outline</i>
        </div>
        <div class="col-6 col-md-3">
          <span class="badge bg-info text-white me-1">Manual</span>
          <small>Manually matched</small>
          <i class="material-icons ms-1" style="font-size: 14px; color: #6c757d; cursor: pointer;"
            title="This company was manually matched by the user.">help_outline</i>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 p-3 border-top shadow-sm"
      style="position: sticky; bottom: 0; background: #fff; z-index: 1030;">
      <button class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="createWatchlist()"
        [disabled]="getSelectedCount() === 0 || (existingCount + getSelectedCount()) > maxCompanies">
        <i class="material-icons me-1" style="font-size: 18px;">add</i>
        Add to {{ isBenchmark ? 'Benchmark' : 'Watchlist' }} ({{ getSelectedCount() }})
      </button>
    </div>
  </div>
</div>

<!-- Progress Overlay -->
<div *ngIf="isProcessing" class="progress-overlay">
  <div class="progress-card">
    <div class="progress-title">Matching Companies... ({{Math.round(progressValue)}}%)</div>
    <div class="progress-bar-container">
      <div class="progress-bar-fill" [style.width.%]="progressValue" [class.blinking]="progressValue >= 90"></div>
    </div>
    <div class="progress-subtitle">
      <span *ngIf="progressValue < 90">Please wait while we process your data</span>
      <span *ngIf="progressValue >= 90">Please don't refresh - process is still running...</span>
    </div>
  </div>
</div>